export default __webpack_public_path__ + "static/media/No Message.921223d5.png";